export default __webpack_public_path__ + "static/WebSite_3DShowcaseMameha_VideoQHD-41ddd7d9eaef2f7259eeab200a3cf412.mp4";